const LOG_PREFIX = "[OCM][PageSense] "
window.ocm_observer = null

let pageSense = async (utils) => {
    return new Promise((resolve, reject) => {
        let pageType = 'ROS';
      
    //utils.loadStyle('.OUTBRAIN .ob-feed-layout .ob-widget-header { color:#003656 !important; }'); //styles for outbrain widget
    utils.loadStyle('.ob-feed-idx-0-11741-81574.FMS_CP_1.ob-grid-layout .ob-rec-text { color:#003656 !important; } .ob-widget-text { margin-top: -50px; max-width: 170px; background: #fff; margin-left: 20px;padding: 0 0 0 10px; } .ob-widget-header { border-top: 2px solid #d91926'); //styles for outbrain widget
      
        let sub_paths = window.location.pathname.replace("/", "").split("/") || [];
		let custom_paths = [
          "poioi-eimaste", 
          "oroi-chrisis",
          "diafimisteite",
          "epikoinonia",
        ];

        sub_paths = sub_paths.filter(String);

        if (sub_paths.length === 0) {
          pageType = "Home";
        } else if (sub_paths.length === 1) {
          if (custom_paths.indexOf(sub_paths[0]) >= 0) {
            pageType = "Custom-1";
          } else {
            pageType = "Category";
          }
        } else if (sub_paths.length === 2) {
          pageType = "Category";
        } else if (sub_paths.length === 3) {
          pageType = "Article";
        }
      
      utils.contentLoaded().then(() => {

          // GAM targeting
          window.googletag.cmd.push(() => {
            googletag.pubads().setTargeting('ocm_site_billing', 'thestival.gr')
          })
        
        })
      
        resolve(pageType)
   });
};
module.exports = pageSense;